export default {"src":"/_next/static/media/tamil nadu.5e9a8f35.svg","height":336,"width":242,"blurWidth":0,"blurHeight":0};